import "@/App.css";
import LegalLandingPage from "@/components/LegalLandingPage";

function App() {
  return <LegalLandingPage />;
}

export default App;
